import { useEffect, useState } from "react";
import TechnicienTable from "../../components/technicien/TechnicienTable";
import TechnicienForm from "../../components/technicien/TechnicienForm";
import {
  getTechniciens,
  createTechnicien,
  updateTechnicien,
  deleteTechnicien
} from "../../api/techniciens.api";

export default function TechnicienPage() {
  const [techniciens, setTechniciens] = useState([]);
  const [technicienEdit, setTechnicienEdit] = useState(null);
   const [formOpen, setFormOpen] = useState(false);

  // Charger les clients
  useEffect(() => {
    loadTechnicien();
    
  }, []);

  const loadTechnicien = async () => {
    const res = await getTechniciens();
  
    setTechniciens(res.data);
      
  };

  // 👉 appelé quand on clique sur ✏️
  const onEdit = (technicien) => {
    setTechnicienEdit(technicien);
    setFormOpen(false);
  };

  // 👉 appelé quand on clique sur 🗑
  const onDelete = async (id) => {
    if (window.confirm("Supprimer ce technicien ?")) {
      await deleteTechnicien(id);
      loadTechnicien();
    }
  };

   
  // Create ou Update
  const onSubmit = async (data) => {
    if (technicienEdit) {
      await updateTechnicien(technicienEdit.id, data);
    } else {
      await createTechnicien(data);
    }
    setTechnicienEdit(null);
    setFormOpen(true);
    loadTechnicien();
  };

  return (
    <div>
      <h1>Liste des techniciens</h1>
     <button onClick={onSubmit} className="btn-add">
        Ajouter un rendez-vous
      </button>
    
       <TechnicienForm onSubmit={onSubmit} technicien={technicienEdit} />
       
      <TechnicienTable
        techniciens={techniciens}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    
    </div>
  );
}
